import React from 'react';
import { StarIcon } from 'lucide-react';
import { Eyebrow, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <SectionShell tone="cream" data-id="element-249" data-mp="3mfhhe7wn41jb">
      <Eyebrow data-id="element-250" data-mp="3r78x1ne9cmuo">Testimonios reales</Eyebrow>
      <SectionTitle data-id="element-251" data-mp="3r8ajsp4myxs8">Lo que opinan médicos que ya usan la Ruta Renal™</SectionTitle>

      <div className="mt-8 grid grid-cols-1 gap-3.5 sm:grid-cols-2" data-id="element-252" data-mp="1zh6ojz9oys">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-navy-100 bg-white p-4 sm:p-5" data-id="element-253" data-mp="41rsh90ra97u">
            <div className="flex gap-0.5" role="img" aria-label="Calificación: 5 de 5 estrellas" data-id="element-254" data-mp="9032bjr1wjq2">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-255" data-mp="2fs3t6g2e4i9h" data-mpi={i} />)}
            </div>
            <blockquote className="mt-3 flex-1 text-[13.5px] leading-relaxed text-navy-800 sm:text-[14.5px]" data-id="element-256" data-mp="1ntat5boqt65o">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-257" data-mp="1isn4uxrwf3f5">
              <img src={t.photo} alt={`Retrato de ${t.name}`} className="h-11 w-11 shrink-0 rounded-full object-cover" width={88} height={88} loading="lazy" data-id="element-258" data-mp="1er1jeo1atgtc" />
              <div className="min-w-0" data-id="element-259" data-mp="22he0aoeiunw2">
                <p className="text-[13.5px] font-bold text-navy-900" data-id="element-260" data-mp="22kjpe3n5hprs">{t.name}</p>
                <p className="text-[12px] font-medium text-navy-600/70" data-id="element-261" data-mp="1xjcjka4kj0nr">{t.country}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <div className="mt-8" data-id="element-262" data-mp="m3fftfs2mc6h">
        <CtaButton label="Quiero los mismos resultados" sub="Únete a más de 1.000 médicos hispanohablantes" data-id="element-263" data-mp="m35q7taxu71b" />
      </div>
    </SectionShell>;
}